import {
  Box,
  Checkbox,
  FormControlLabel,
  Switch,
  Typography,
} from '@material-ui/core';
import { TabProps } from './types';
import { GAR_REPOSITORY_TYPES } from './defaults';

export function ArtifactRegistryTab({ config, onChange }: TabProps) {
  const handleEnableChange = (_: unknown, checked: boolean) => {
    onChange({
      ...config,
      enable_gar: checked,
      gar_repository_types: checked ? ['DOCKER'] : [],
    });
  };

  const handleTypeToggle = (type: string, checked: boolean) => {
    const updated = checked
      ? [...config.gar_repository_types, type]
      : config.gar_repository_types.filter(t => t !== type);
    onChange({ ...config, gar_repository_types: updated });
  };

  const selectedTypes = new Set(config.gar_repository_types);

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
      <Typography variant="subtitle1">Google Artifact Registry</Typography>
      <Typography variant="body2" color="textSecondary">
        Enable Artifact Registry to store and manage container images, language
        packages, and other artifacts.
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={config.enable_gar}
            onChange={handleEnableChange}
            color="primary"
          />
        }
        label="Enable Artifact Registry"
      />

      {config.enable_gar && (
        <Box display="flex" flexDirection="column" style={{ gap: 4, marginLeft: 16 }}>
          <Typography variant="subtitle2" gutterBottom>
            Repository Types
          </Typography>
          {GAR_REPOSITORY_TYPES.map(type => (
            <FormControlLabel
              key={type}
              control={
                <Checkbox
                  checked={selectedTypes.has(type)}
                  onChange={(_, checked) => handleTypeToggle(type, checked)}
                  color="primary"
                />
              }
              label={type}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
